import Gumshoe from 'gumshoejs'

const spy = new Gumshoe('.banner .nav .nav_link', { offset: 90 });